export const questions = [{
  question: 'How well can my team handle uncomfortable conversation?',
  answers: [
    'We shy away from topics that might be uncomfortable.',
    'When we come to an uncomfortable topic, we take it offline or outside the group.',
    'When we come to an uncomfortable topic some people disengage, others try to continue the topic.',
    'We are able to deal with some uncomfortable topics sometimes as a whole team.',
    'We are usually able to deal with uncomfortable topics.',
    'We always stick to uncomfortable topics until we completely resolve them.'
  ]
}, {
  question: 'How well do I handle uncomfortable conversation with my team?',
  answers: [
    'Much lower than the group\'s capacity, I find it a bit intimidating and tend to disengage.',
    'Much higher than the group\'s - we don\'t resolve uncomfortable issues.',
    'Higher than the group\'s - I\'m frustrated we don\'t stick at uncomfortable topics for long.',
    'Lower than the group\'s capacity - I try to, but I can\'t last as long as the group does.',
    'About the same as the group\'s - I can stay with the group when they go to uncomfortable places.',
    'Slightly higher than the group\'s - I push this group to stay in discomfort longer.'
    ],
  consensus: {
    question: 'How varied is the personal capacity for uncomfortable conversation across this team?',
    answers: [
      'Not varied at all - we all dislike uncomfortable conversation equally!',
      'Too varied. When debates break out in the group some people "disappear".',
      'Concentrated: A few of us have very high capacity, others have low to very low capacity.',
      'Somewhat varied: some of us have high capacity and others low.',
      'Somewhat similar: we have a little variation, but we can debate at a level most feel comfortable with.',
      'Very similar: everyone in the group can engage with discomfort at a level we find productive.'
    ]
  }
}, {
  question: 'How much do people feel they can share in this group?',
  answers: [
    'There is a lot "unsaid" in this group.',
    'Only some people share with the group, some people rarely share.',
    'We can all share what we are thinking when it\'s not controversial. We have important things "unsaid".',
    'Some people can raise controversial topics, but we still have some things "unsaid".',
    'Not much is left "unsaid", nearly anyone can raise uncomfortable topics.',
    'We don\'t have anything "unsaid" in this group, everyone can say what is on their mind.'
  ]
}, {
  question: 'How much do we debate and disagree?',
  answers: [
    'When we do debate or argue, it is rarely constructive and does not end well.',
    'We are polite, we avoid disagreement or debates.',
    'Some of us can debate constructively, but others avoid or do not engage in debates.',
    'We can all debate constructively, but only about things that are less important.',
    'Some of us can debate constructively about important things.',
    'We are all able to debate constructively about important things.'
  ]
}, {
  question: 'Can we comment on and challenge each other\'s domains?',
  answers: [
    'None of us know what the others in our team are working on.',
    'Some of us know what some of us working on.',
    'We generally know what we are each working on, but we only comment on our own work.',
    'We know what others are working on, and occasionally comment on or question each other.',
    'Some of us are able to provide meaningful input into others\' projects and work.',
    'We all know what we are working on.  We all ask for and provide meaningful input to each other.'
  ]
}, {
  question: 'Do we set and uphold expectations with each other?',
  answers: [
    'We have never tried to set expectations of each other, or to hold each other to account.',
    'We have a couple of informal expectations of each other. But we don\'t often refer to them.',
    'We have an agreed set of expectations for membership of this team (formal or informal).',
    'We have an agreed set of expectations (formal or informal), and we sometimes call each other out about them.',
    'We have an agreed set of expectations (formal or informal), we regularly refer to them and encourage compliance.',
    'We have an agreed set of expectations and we each hold others to account over them.'
  ]
}, {
  question: 'How well do we engage in real discourse?',
  answers: [
    'In our meetings only one person speaks. Everyone else listens or tunes out.',
    'Our meetings are "hub and spoke": our leader asks questions of each person in turn and they answer.',
    'In our meetings a few regulars engage in discussion, the rest of us watch or tune out.',
    'In our meetings we create space for everyone to comment and engage, but few people do.',
    'In our meetings we create space for everyone to comment and engage, and most people do.',
    'In our meetings the conversation bounces naturally around the whole team.'
  ]
}, {
  question: 'How well do we know each other?',
  answers: [
    'We know nothing about each other as people.',
    'We know a little about each other at a surface level.',
    'Some of us have deep relationships, others don\'t know each other well.',
    'We all know each other, but the depth is quite varied.',
    'We all know each other roughly equally, and reasonably well.',
    'We have a common, shared and meaningful understanding of each other as people.'
  ]
}, {
  question: 'How good are we at discussing our team performance?',
  answers: [
    'We discuss our metrics, our outputs and our work, but never how we are working as a team.',
    'We occasionally talk about our performance as a team, but always in retrospect and in generalities.',
    'We review how we are working as a team regularly, but only in retrospect and in generalities.',
    'We are able to review how we are working together in specifics, but not in real time.',
    'We can talk about how we are performing in close to real time, but in general, not specifics.',
    'We call attention to the specifics of how we are working together in or close to real time.'
  ]
}, {
  question: 'How good are we at improving the way we work together?',
  answers: [
    'We haven\'t really worked on improving the way we work together as a team.',
    'Our team performance talks don\'t lead to actionable outcomes - we "admire the problem".',
    'Our team performance talks lead to generic resolutions, but aren\'t really actionable.',
    'Our team performance talks lead to specific actionable points, but only at a team level.',
    'Our team performance talks lead to specific actions at both team and individual level.',
    'We hold ourselves accountable to implementing specific actions at both team and individual level.'
  ]
}, {
  question: 'How often do team members update their understanding of our world?',
  answers: [
    'I wouldn\'t know what our commonly held beliefs are.',
    'We tend to stick to our commonly held beliefs.',
    'We can change our minds on some less important things, but not our core beliefs or thinking.',
    'We\'re open to change, but we don\'t debate important issues enough to challenge our thinking or beliefs.',
    'We do debate and challenge our thinking and beliefs, but we don\'t often actually change them.',
    'We regularly challenge our core assumptions and are open to changing how we understand the world.'
  ]
}, {
  question: 'How often do we create a shared understanding of our world?',
  answers: [
    'We only discuss a shared narrative in response to an event, crisis, or change.',
    'We get told our shared understanding by our team lead or by head office, or similar.',
    'We share our differing views of the world but don\'t work to reconcile them.',
    'We share divergent views, and the majority opinion becomes our new shared understanding.',
    'We share divergent views and debate them to co-create a new shared understanding.',
    'We regularly share and debate our differing views to continuously evolve our understanding.'
  ]
}]